import React from "react";
import { V3Loader } from "../Loader";

export const withGlobalPageSpinner = (busy: boolean, component: JSX.Element) => {
    if (busy) return <V3Loader fullScreen />;
    return component;
}